/**-----------------------------------------------------------------------------------------
* Copyright © 2023 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the package root for more information
*-------------------------------------------------------------------------------------------*/
"use client";
import * as r from "react";
import { validatePackage as Ve } from "@progress/kendo-licensing";
import * as bt from "react-dom";
import g from "prop-types";
import { dispatchDragAndDrop as xt, getScrollableParent as Fe, autoScroll as yt } from "@progress/kendo-draggable-common";
const qe = r.createContext(0), An = () => r.useContext(qe);
qe.displayName = "KendoReactZIndexContext";
const pt = () => typeof document < "u" ? document : {};
class Ke {
  constructor() {
    this.scrollbar = 0;
  }
  get scrollbarWidth() {
    const t = pt();
    if (!this.scrollbar && t && t.createElement) {
      const n = t.createElement("div");
      n.style.cssText = "overflow:scroll;overflow-x:hidden;zoom:1;clear:both;display:block", n.innerHTML = "&nbsp;", t.body.appendChild(n), this.scrollbar = n.offsetWidth - n.scrollWidth, t.body.removeChild(n);
    }
    return this.scrollbar;
  }
}
const fe = !!// from fbjs
(typeof window < "u" && window.document && window.document.createElement), kt = (e) => {
  var t;
  return !!(typeof e == "function" && ((t = e.prototype) != null && t.isReactComponent));
}, Dt = (e) => !!(e.$$typeof && typeof e.render == "function"), wn = (e) => typeof Comment != "string" && (kt(e) || Dt(e)), We = (...e) => {
  const t = {}, n = (s) => typeof s == "object" ? Object.keys(s).forEach((l) => {
    t[l] = s[l];
  }) : t[s] = !0, o = (s) => s.filter((l) => l !== !0 && !!l).map((l) => Array.isArray(l) ? o(l) : n(l));
  return o(e), Object.keys(t).map((s) => t[s] && s || null).filter((s) => s !== null).join(" ");
}, At = (e) => e ? new Date(e.getTime()) : null;
function Pn(e) {
  const t = {};
  return _e(e, t), t;
}
function _e(e, t) {
  for (let n in e)
    if (e.hasOwnProperty(n)) {
      const o = e[n];
      t[n] = $e(o, t[n]);
    }
}
function $e(e, t) {
  if (Array.isArray(e))
    return wt(e);
  if (e instanceof Date)
    return At(e);
  if (r.isValidElement(e))
    return r.cloneElement(e, e.props);
  if (e && typeof e == "object") {
    const n = t || {};
    return _e(e, n), n;
  } else
    return e;
}
function wt(e) {
  return e.map((t) => $e(t, void 0));
}
const In = (e) => {
  if (e) {
    if ((e instanceof HTMLInputElement || e.tabIndex !== -1) && e.focus) {
      e.focus();
      return;
    }
    const t = e.querySelector('input, [tabindex]:not([tabindex="-1"])');
    t && t.focus && t.focus();
  }
};
class On {
}
const Pt = -1, It = 0, Mn = (e, t, n) => {
  const o = typeof e == "string" ? parseInt(e) : e;
  if (!Number.isNaN(o))
    return o !== void 0 ? o : t ? n ? void 0 : Pt : It;
}, Ot = /\[(?:(\d+)|['"](.*?)['"])\]|((?:(?!\[.*?\]|\.).)+)/g;
function et(e) {
  const t = [];
  return e.replace(Ot, function(n, o, s, l) {
    t.push(o !== void 0 ? o : s || l);
  }), t;
}
const z = {};
z.undefined = () => {
};
function Sn(e) {
  if (z[e])
    return z[e];
  const t = et(e);
  return z[e] = function(n) {
    let o = n;
    for (let s = 0; s < t.length && o; s++)
      o = o[t[s]];
    return o;
  }, z[e];
}
const Xe = () => {
  let e = "", t, n;
  for (t = 0; t < 32; t++)
    n = Math.random() * 16 | 0, (t === 8 || t === 12 || t === 16 || t === 20) && (e += "-"), e += (t === 12 ? 4 : t === 16 ? n & 3 | 8 : n).toString(16);
  return e;
}, Rn = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  esc: 27,
  space: 32,
  pageUp: 33,
  pageDown: 34,
  end: 35,
  home: 36,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  delete: 46
}, C = function() {
}, Ln = () => !fe || !document.body ? !1 : new Ke().scrollbarWidth, Tn = () => {
  if (!fe || !document.body)
    return !1;
  let e = new Ke().scrollbarWidth;
  document.body.style.setProperty("--kendo-scrollbar-width", `${e}px`);
}, F = {};
F.undefined = (e) => e;
const Mt = (e, t) => t && t.arrays && !isNaN(Number(e)) ? [] : {};
function Nn(e) {
  if (F[e])
    return F[e];
  const t = et(e);
  return F[e] = (n, o, s) => {
    let l = n;
    const c = t.length - 1;
    for (let i = 0; i < c && l; i++)
      l = l[t[i]] = l[t[i]] || Mt(t[i + 1], s);
    l[t[c]] = o;
  }, F[e];
}
function Ye(e, t, n) {
  return n ? { ...e, [t]: n.length ? [...n] : void 0 } : e && e[t] ? [...e[t]] : [];
}
function tt(e, t, n) {
  if (e[t]) {
    let o = Ye(e, t).map((s) => tt(s, t, n));
    return n(Ye(e, t, o));
  }
  return n(e);
}
const Hn = (e, t, n) => [...e.map((o) => tt(o, t, n))], Bn = (e, t, n, o) => {
  let s = e;
  const l = [];
  for (let f = 0; f < t.length; f++)
    s = s[t[f]], s = Array.isArray(s) ? s : s[n], l.push(s);
  const c = l.length > 1 ? l[l.length - 2] : e, i = t[t.length - 1], h = o(c[i]);
  c.splice(i, 1, h);
}, jn = (e, t, n) => Object.assign(
  {},
  e,
  e[t] ? { [t]: e[t].slice() } : {},
  n || {}
), Qn = (e, t, n) => {
  const o = [], s = [...t];
  if (s.length) {
    let l = e[s.shift() || 0];
    for (o.push(l); s.length && n; )
      l = l[n][s.shift() || 0], o.push(l);
  }
  return o;
}, St = ["telerik.com", "progress.com", "stackblitz.io", "csb.app"], zn = Ve;
function Fn(e) {
  return !St.some((n) => {
    var o;
    return (o = globalThis.document) == null ? void 0 : o.location.hostname.endsWith(n);
  }) && !Ve(e);
}
const Xn = (e) => {
  if (!fe)
    return !1;
  const t = e ? e.ownerDocument : document;
  if (!t || !t.body)
    return !1;
  const n = 10, o = t.createElement("div");
  o.style.transform = "matrix(10, 0, 0, 10, 0, 0)";
  const s = t.createElement("div");
  s.appendChild(t.createTextNode("child")), s.style.position = "fixed", s.style.top = n + "px", o.appendChild(s), t.body.appendChild(o);
  const l = s.getBoundingClientRect().top !== n;
  return t.body.removeChild(o), l;
}, Rt = "https://www.telerik.com/kendo-react-ui/components/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-banner";
let Ge = !1;
const Yn = () => {
  const [e, t] = r.useState(!0), [n, o] = r.useState(!1);
  r.useEffect(() => {
    Ge || (o(!0), Ge = !0);
  }, []);
  const s = () => {
    t(!1);
  }, l = /* @__PURE__ */ r.createElement(r.Fragment, null, e && /* @__PURE__ */ r.createElement("div", { style: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "fixed",
    top: "16px",
    right: "16px",
    padding: "12px",
    borderRadius: "4px",
    boxShadow: "0px 4px 5px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.03)",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    backgroundColor: "#FFC000",
    color: "#1E1E1E",
    zIndex: 999
  } }, /* @__PURE__ */ r.createElement("span", { style: { display: "flex", alignSelf: "center", marginRight: "8px" } }, /* @__PURE__ */ r.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" }, /* @__PURE__ */ r.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1L0 15H16L8 1ZM7 6V11H9V6H7ZM7 14V12H9V14H7Z", fill: "#1E1E1E" }))), /* @__PURE__ */ r.createElement("span", null, "No valid license found for KendoReact. Learn how to activate your license."), /* @__PURE__ */ r.createElement("div", { style: { display: "flex", alignItems: "center", marginLeft: "24px" } }, /* @__PURE__ */ r.createElement("a", { href: Rt, style: { marginRight: "8px", display: "flex" } }, /* @__PURE__ */ r.createElement(
    "button",
    {
      title: "Learn More",
      style: {
        display: "inline-flex",
        position: "relative",
        border: "none",
        borderRadius: "4px",
        padding: "5px",
        backgroundColor: "transparent",
        transition: "color 0.2s ease-in-out",
        outline: "none",
        cursor: "pointer"
      }
    },
    /* @__PURE__ */ r.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" }, /* @__PURE__ */ r.createElement("path", { d: "M15 8C15 11.8656 11.8656 15 8 15C4.13437 15 1 11.8656 1 8C1 4.13437 4.13437 1 8 1C11.8656 1 15 4.13437 15 8ZM14 8C14 4.6875 11.3125 2 8 2C4.6875 2 2 4.6875 2 8C2 11.3125 4.6875 14 8 14C11.3125 14 14 11.3125 14 8ZM11 6C11 7.4125 10.2687 8.05937 9.73125 8.53125C9.25937 8.94688 9 9.17813 9 10H7C7 8.275 7.84688 7.525 8.40938 7.03125C8.84062 6.65312 9 6.50938 9 6C9 5.45 8.55 5 8 5C7.45 5 7 5.45 7 6H5C5 4.34375 6.34375 3 8 3C9.65625 3 11 4.34375 11 6ZM9 13V11H7V13H9Z", fill: "#1E1E1E" }))
  )), /* @__PURE__ */ r.createElement(
    "button",
    {
      title: "Close",
      style: {
        display: "inline-flex",
        position: "relative",
        border: "none",
        borderRadius: "4px",
        padding: "5px",
        backgroundColor: "transparent",
        transition: "color 0.2s ease-in-out",
        outline: "none",
        cursor: "pointer"
      },
      onClick: s
    },
    /* @__PURE__ */ r.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" }, /* @__PURE__ */ r.createElement("path", { d: "M13 4.41562L9.41563 8L13 11.5844L11.5844 13L8 9.41563L4.41562 13L3 11.5844L6.58437 8L3 4.41562L4.41562 3L8 6.58437L11.5844 3L13 4.41562Z", fill: "#1E1E1E" }))
  ))));
  return /* @__PURE__ */ r.createElement(r.Fragment, null, /* @__PURE__ */ r.createElement(
    "div",
    {
      style: {
        position: "absolute",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        opacity: 0.12,
        zIndex: 101,
        pointerEvents: "none",
        backgroundImage: "url('data:image/png;base64,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')"
      }
    }
  ), n && bt.createPortal(l, document.body));
};
function Gn(e, t, n, o) {
  if (e) {
    const s = {
      syntheticEvent: t,
      nativeEvent: t.nativeEvent,
      target: n
    };
    e.call(void 0, Object.assign(s, o));
  }
}
function Lt({ onFocus: e, onBlur: t, onSyncFocus: n, onSyncBlur: o }) {
  const s = r.useRef(!1), l = r.useRef(0), c = r.useCallback(
    (f) => {
      clearTimeout(l.current), l.current = window.setTimeout(() => f());
    },
    [l]
  ), i = r.useCallback(
    (...f) => {
      clearTimeout(l.current), n && n.call(void 0, f[0]), !s.current && (s.current = !0, e && e.call(void 0, ...f));
    },
    [s, e, n]
  ), h = r.useCallback(
    (...f) => {
      o && o.call(void 0, f[0]), c(() => {
        s.current && t && (s.current = !1, t.call(void 0, ...f));
      });
    },
    [s, c, t, o]
  );
  return r.useEffect(() => () => {
    clearTimeout(l.current);
  }, []), {
    onFocus: i,
    onBlur: h
  };
}
const Jn = ({
  children: e,
  onFocus: t,
  onBlur: n,
  onSyncFocus: o,
  onSyncBlur: s
}) => {
  const l = Lt({ onFocus: t, onBlur: n, onSyncFocus: o, onSyncBlur: s });
  return /* @__PURE__ */ r.createElement(r.Fragment, null, e.call(void 0, { ...l }));
}, Tt = (e, t) => r.useContext(e)(t), Un = () => r.createContext((e) => e), Zn = (e, t) => r.forwardRef((n, o) => {
  const s = Tt(e, n);
  return /* @__PURE__ */ r.createElement(t, { ...s, ref: o });
}), Nt = typeof window < "u" ? r.useLayoutEffect : r.useEffect;
function Ht(e) {
  const [t, n] = r.useState(!1);
  r.useEffect(() => {
    n(!0);
  }, []);
  const [o, s] = r.useState(() => {
    if (e)
      return e;
    if (t)
      return Xe();
  });
  return Nt(() => {
    o === void 0 && s(Xe());
  }, []), r.useId ? e ?? r.useId() : o;
}
const Vn = (e) => r.forwardRef((t, n) => {
  const o = Ht(t.id);
  return /* @__PURE__ */ r.createElement(e, { ...t, id: o, ref: n });
});
function qn(e, t, n) {
  const [o, s] = r.useState(t);
  return r.useEffect(
    () => {
      if (!o && window && e.current) {
        const l = window.getComputedStyle(e.current).direction;
        l && s(l);
      }
    },
    n
  ), o;
}
function Kn(e, t, n) {
  const [o, s] = r.useState(t);
  return r.useEffect(
    () => {
      if (!o && window && e.current) {
        const l = window.getComputedStyle(e.current).direction;
        l && s(l);
      }
    },
    n
  ), o;
}
const Bt = (e, t, n = {}) => {
  const o = r.useCallback(
    (u) => {
      n.onMouseDown && n.onMouseDown.call(void 0, u), e.onMouseDown && e.onMouseDown.call(void 0, {
        target: t.current,
        syntheticEvent: u
      });
    },
    [n.onMouseDown, e.onMouseDown, t]
  ), s = r.useCallback(
    (u) => {
      n.onMouseUp && n.onMouseUp.call(void 0, u), e.onMouseUp && e.onMouseUp.call(void 0, {
        target: t.current,
        syntheticEvent: u
      });
    },
    [n.onMouseUp, e.onMouseUp, t]
  ), l = r.useCallback(
    (u) => {
      n.onClick && n.onClick.call(void 0, u), e.onClick && e.onClick.call(void 0, {
        target: t.current,
        syntheticEvent: u
      });
    },
    [n.onClick, e.onClick, t]
  ), c = r.useCallback(
    (u) => {
      n.onDoubleClick && n.onDoubleClick.call(void 0, u), e.onDoubleClick && e.onDoubleClick.call(void 0, {
        target: t.current,
        syntheticEvent: u
      });
    },
    [n.onDoubleClick, e.onDoubleClick, t]
  ), i = r.useCallback(
    (u) => {
      n.onMouseEnter && n.onMouseEnter.call(void 0, u), e.onMouseEnter && e.onMouseEnter.call(void 0, {
        target: t.current,
        syntheticEvent: u
      });
    },
    [n.onMouseEnter, e.onMouseEnter, t]
  ), h = r.useCallback(
    (u) => {
      n.onMouseLeave && n.onMouseLeave.call(void 0, u), e.onMouseLeave && e.onMouseLeave.call(void 0, {
        target: t.current,
        syntheticEvent: u
      });
    },
    [n.onMouseLeave, e.onMouseLeave, t]
  ), f = r.useCallback(
    (u) => {
      n.onMouseMove && n.onMouseMove.call(void 0, u), e.onMouseMove && e.onMouseMove.call(void 0, {
        target: t.current,
        syntheticEvent: u
      });
    },
    [n.onMouseMove, e.onMouseMove, t]
  ), d = r.useCallback(
    (u) => {
      n.onMouseOut && n.onMouseOut.call(void 0, u), e.onMouseOut && e.onMouseOut.call(void 0, {
        target: t.current,
        syntheticEvent: u
      });
    },
    [n.onMouseOut, e.onMouseOut, t]
  ), m = r.useCallback(
    (u) => {
      n.onMouseOver && n.onMouseOver.call(void 0, u), e.onMouseOver && e.onMouseOver.call(void 0, {
        target: t.current,
        syntheticEvent: u
      });
    },
    [n.onMouseOver, e.onMouseOver, t]
  );
  return {
    onClick: l,
    onMouseUp: s,
    onMouseDown: o,
    onDoubleClick: c,
    onMouseEnter: i,
    onMouseLeave: h,
    onMouseMove: f,
    onMouseOut: d,
    onMouseOver: m
  };
}, Wn = (e) => [e, {}];
var X = /* @__PURE__ */ ((e) => (e[e.add = 0] = "add", e[e.remove = 1] = "remove", e))(X || {});
const Je = (e = []) => {
  const t = r.useRef(e), n = r.useCallback(
    (o) => {
      switch (o.type) {
        case 0:
          t.current.push(o.item);
          break;
        case 1: {
          const s = t.current.indexOf(o.item);
          t.current.splice(s, 1);
          break;
        }
      }
    },
    []
  );
  return [t.current, n];
}, jt = (e) => {
  const t = r.useCallback(
    () => e.current && e.current.element ? e.current.element : e.current,
    [e]
  );
  return r.useCallback(() => {
    const o = t();
    return o && o.ownerDocument || document;
  }, [t]);
}, _n = (e) => {
  const t = jt(e);
  return r.useCallback(() => {
    const o = t();
    return o && o.defaultView || window;
  }, [t]);
}, nt = {
  default: "",
  xsmall: "k-icon-xs",
  small: "k-icon-sm",
  medium: "k-icon-md",
  large: "k-icon-lg",
  xlarge: "k-icon-xl",
  xxlarge: "k-icon-xxl",
  xxxlarge: "k-icon-xxxl"
}, $n = (e) => e.replace(/^k-i-/, ""), Qt = (e) => "k-i-" + e, er = g.shape({
  name: g.string.isRequired,
  content: g.string.isRequired,
  viewBox: g.string.isRequired
}), ue = (e, t) => {
  const [n, o] = r.useContext(e), [s, l] = r.useState(t);
  return [
    n !== void 0 ? n : s,
    (...h) => {
      n !== void 0 ? o(...h) : l(h[0]);
    }
  ];
}, rt = r.createContext([
  void 0,
  C
]), he = r.createContext([
  void 0,
  C
]), ot = r.createContext([[], C, C]), ge = r.createContext([[], C, C]), zt = 2e3;
function Ft(e, t, n = {}) {
  const {
    onPress: o = C,
    onRelease: s = C,
    onDragStart: l = C,
    onDrag: c = C,
    onDragEnd: i = C
  } = t, {
    hint: h = null,
    mouseOnly: f = !1,
    autoScroll: d = !0,
    scrollContainer: m = null
  } = n, [u, x] = r.useState(!1), [y, w] = r.useState(!1), [E] = ue(he), [R, M] = ue(rt), [T] = r.useContext(ge), [I, P, O] = r.useContext(ot), p = r.useRef({ x: 0, y: 0 }), q = r.useRef(), K = r.useRef(!1), xe = r.useRef(), j = r.useRef(null), W = r.useRef(!1), ye = r.useRef({ x: 0, y: 0 }), pe = r.useRef({ x: 0, y: 0 }), U = r.useRef({ x: 0, y: 0 }), ke = r.useRef({ x: 0, y: 0 }), De = r.useRef({ x: 0, y: 0 }), Ae = r.useRef({ x: 0, y: 0 }), dt = !!(typeof window < "u" && window.PointerEvent), we = !f && dt, L = r.useCallback(
    () => e.current && e.current.element ? e.current.element : e.current,
    [e]
  ), ft = r.useCallback(
    () => h && h.current && h.current.element ? h.current.element : h ? h.current : null,
    [h]
  ), Pe = r.useCallback(
    () => m && m.current && m.current.element ? m.current.element : m ? m.current : null,
    [m]
  ), Ie = r.useCallback(
    () => typeof d == "object" && d.boundaryElementRef && d.boundaryElementRef.current && d.boundaryElementRef.current.element ? d.boundaryElementRef.current.element : typeof d == "object" && d.boundaryElementRef && d.boundaryElementRef.current ? d.boundaryElementRef.current : null,
    [d]
  ), Q = r.useRef(null);
  r.useImperativeHandle(Q, () => ({
    element: L(),
    hint: ft(),
    onPress: ht,
    onDragStart: mt,
    onDrag: vt,
    onDragEnd: Ct,
    onRelease: gt,
    data: e.current
  }));
  const Z = r.useCallback(
    () => {
      const a = L();
      return a && a.ownerDocument || document;
    },
    [L]
  ), N = r.useCallback(
    () => {
      const a = Z();
      return a && a.defaultView || window;
    },
    [Z]
  ), Oe = r.useCallback(
    () => ({
      drag: R ? R.current : null,
      drop: E ? E.current : null,
      drags: I.map((a) => a.current),
      drops: T.map((a) => a.current),
      pressed: u,
      ignoreMouse: K.current,
      scrollOffset: De.current,
      offset: ye.current,
      pageOffset: pe.current,
      initialScrollOffset: Ae.current,
      clientOffset: U.current,
      initialClientOffset: ke.current,
      velocity: p.current,
      autoScroll: !!(typeof d == "object" ? d.enabled !== !1 : d),
      scrollableParent: Ie(),
      autoScrollDirection: typeof d == "object" ? d.direction : { horizontal: !0, vertical: !0 },
      isScrolling: y
    }),
    [R, E, I, T, u, d, Ie, y]
  ), Me = r.useCallback(
    (a) => {
      x(a);
    },
    []
  ), Se = r.useCallback(
    (a) => {
      w(a);
    },
    []
  ), Re = r.useCallback(
    (a) => {
      p.current = a;
    },
    []
  ), Le = r.useCallback(
    (a) => {
      ye.current = a;
    },
    []
  ), Te = r.useCallback(
    (a) => {
      U.current = a;
    },
    []
  ), Ne = r.useCallback(
    (a) => {
      pe.current = a;
    },
    []
  ), He = r.useCallback(
    (a) => {
      ke.current = a;
    },
    []
  ), Be = r.useCallback(
    (a) => {
      De.current = a;
    },
    []
  ), je = r.useCallback(
    (a) => {
      Ae.current = a;
    },
    []
  ), ht = r.useCallback(
    (a) => {
      o(a);
    },
    [o]
  ), gt = r.useCallback(
    (a) => {
      s(a);
    },
    [s]
  ), mt = r.useCallback(
    (a) => {
      M(Q, { target: e.current, event: a }), l(a);
    },
    [M, e, l]
  ), vt = r.useCallback(
    (a) => {
      c(a);
    },
    [c]
  ), Ct = r.useCallback(
    (a) => {
      W.current || (M(null, { target: e.current, event: a }), i(a));
    },
    [i, M, e]
  ), v = r.useCallback(
    (a) => {
      xt(
        Oe(),
        { event: a, payload: Q.current },
        {
          onVelocityChange: Re,
          onOffsetChange: Le,
          onClientOffsetChange: Te,
          onPageOffsetChange: Ne,
          onInitialClientOffsetChange: He,
          onScrollOffsetChange: Be,
          onInitialScrollOffsetChange: je,
          onIsPressedChange: Me,
          onIsScrollingChange: Se
        }
      );
    },
    [
      Oe,
      Re,
      Le,
      Ne,
      Te,
      He,
      je,
      Me,
      Be,
      Se
    ]
  ), _ = r.useCallback(
    (a) => {
      v(a);
    },
    [v]
  ), $ = r.useCallback(
    (a) => {
      v(a);
    },
    [v]
  ), ee = r.useCallback(
    (a) => {
      v(a);
    },
    [v]
  ), te = r.useCallback(
    (a) => {
      v(a);
    },
    [v]
  ), ne = r.useCallback(
    (a) => {
      v(a);
    },
    [v]
  ), re = r.useCallback(
    (a) => {
      v(a);
    },
    [v]
  ), oe = r.useCallback(
    (a) => {
      v(a);
    },
    [v]
  ), se = r.useCallback(
    (a) => {
      a.preventDefault(), v(a);
    },
    [v]
  ), le = r.useCallback(
    (a) => {
      a.preventDefault(), v(a);
    },
    [v]
  ), ce = r.useCallback(
    (a) => {
      a.preventDefault(), v(a);
    },
    [v]
  ), ae = r.useCallback(
    (a) => {
      if (a.touches.length === 0 && a.changedTouches.length === 1) {
        const b = N();
        K.current = !0, xe.current = b.setTimeout(() => {
          K.current = !1;
        }, zt);
      }
      v(a);
    },
    [v, N]
  ), ie = r.useCallback(
    (a) => {
      v(a);
    },
    [v]
  ), Qe = r.useCallback(
    () => {
      const a = L();
      if (a) {
        const b = a.style.touchAction;
        return a.style.touchAction = "none", () => {
          a.style.touchAction = b;
        };
      }
    },
    [L]
  ), ze = r.useCallback(
    () => (P(Q), () => {
      O(Q);
    }),
    [O, P]
  ), Et = () => {
    const a = N(), b = L(), D = Z();
    return we ? (b && (j.current = Fe(b), j.current && j.current.addEventListener("scroll", ie, { passive: !0 }), b.addEventListener("pointerdown", _, { passive: !0 })), u && (D.addEventListener("pointermove", $), D.addEventListener("pointerup", te, !0), D.addEventListener("contextmenu", se), D.addEventListener("pointercancel", ee, { passive: !0 }))) : (a.addEventListener("touchmove", C, { capture: !1, passive: !1 }), b && (b.addEventListener("mousedown", ne, { passive: !0 }), f || (b.addEventListener("touchstart", le, { passive: !0 }), u && (b.addEventListener("touchmove", ce, { passive: !0 }), b.addEventListener("touchend", ae, { passive: !0 })))), u && (D.addEventListener("mousemove", re, { passive: !0 }), D.addEventListener("mouseup", oe, { passive: !0 }))), () => {
      j.current && j.current.removeEventListener("scroll", ie), b && (b.removeEventListener("pointerdown", _), b.removeEventListener("mousedown", ne), b.removeEventListener("touchstart", le), b.removeEventListener("touchmove", ce), b.removeEventListener("touchend", ae)), D.removeEventListener("pointermove", $), D.removeEventListener("pointerup", te, !0), D.removeEventListener("contextmenu", se), D.removeEventListener("pointercancel", ee), D.removeEventListener("mousemove", re), D.removeEventListener("mouseup", oe), a.removeEventListener("touchmove", C), a.clearTimeout(xe.current);
    };
  };
  r.useEffect(() => {
    const a = N();
    if (y) {
      const b = Pe() || Fe(document.elementFromPoint(U.current.x, U.current.y));
      a.clearInterval(q.current), q.current = a.setInterval(() => {
        yt(b, { x: p.current.x, y: p.current.y });
      }, 50);
    }
    return () => {
      a.clearInterval(q.current);
    };
  }, [L, Pe, N, y]), r.useEffect(Qe, [Qe]), r.useEffect(Et, [
    u,
    N,
    L,
    Z,
    f,
    we,
    se,
    ne,
    re,
    oe,
    ee,
    _,
    $,
    te,
    ae,
    ce,
    le,
    ie
  ]), r.useEffect(() => (W.current = !1, () => {
    W.current = !0;
  }), []), r.useLayoutEffect(ze, [ze]);
}
function Xt(e, t = {
  onDragEnter: C,
  onDragOver: C,
  onDragLeave: C,
  onDrop: C
}) {
  const {
    onDragEnter: n = C,
    onDragOver: o = C,
    onDragLeave: s = C,
    onDrop: l = C
  } = t, [, c] = ue(he), [, i, h] = r.useContext(ge), f = r.useCallback(
    () => e.current && e.current.element ? e.current.element : e.current,
    [e]
  ), d = r.useRef(null);
  r.useImperativeHandle(d, () => ({
    element: f(),
    onDragEnter: m,
    onDragOver: u,
    onDragLeave: x,
    onDrop: y,
    data: e.current
  }));
  const m = r.useCallback(
    (E) => {
      c(d, { target: e.current, event: E }), n(E);
    },
    [c, e, n]
  ), u = r.useCallback(
    (E) => {
      o(E);
    },
    [o]
  ), x = r.useCallback(
    (E) => {
      c(null, { target: e.current, event: E }), s(E);
    },
    [c, e, s]
  ), y = r.useCallback(
    (E) => {
      c(null, { target: e.current, event: E }), l(E);
    },
    [c, e, l]
  ), w = r.useCallback(
    () => (i(d), () => {
      h(d);
    }),
    [h, i]
  );
  r.useLayoutEffect(w, [w]);
}
const Ue = (e, t, n) => {
  const [o, s] = r.useState(t || e), l = r.useCallback(
    (c, i) => {
      s(c), n && n.call(void 0, { ...i, value: c });
    },
    [n, s]
  );
  return [t !== void 0 ? t : o, l];
}, me = r.forwardRef((e, t) => {
  const {
    className: n,
    name: o,
    themeColor: s,
    size: l,
    flip: c,
    style: i,
    id: h,
    tabIndex: f,
    ...d
  } = e, m = r.useRef(null), u = r.useRef(null);
  r.useImperativeHandle(m, () => ({
    element: u.current
  })), r.useImperativeHandle(t, () => m.current);
  const x = r.useMemo(
    () => l || Ze.size,
    [l]
  ), y = r.useMemo(
    () => c || Ze.flip,
    [c]
  ), w = r.useMemo(
    () => We(
      "k-icon",
      "k-font-icon",
      o && Qt(o),
      {
        [`k-color-${s}`]: s,
        "k-flip-h": y === "horizontal" || y === "both",
        "k-flip-v": y === "vertical" || y === "both"
      },
      nt[x],
      n
    ),
    [o, s, x, y, n]
  ), E = Bt(e, m);
  return /* @__PURE__ */ r.createElement(
    "span",
    {
      ref: u,
      ...d,
      ...E,
      className: w,
      id: h,
      tabIndex: f,
      style: i,
      role: "presentation"
    }
  );
});
me.propTypes = {
  style: g.object,
  classNames: g.string,
  name: g.string,
  themeColor: g.oneOf([
    "inherit",
    "primary",
    "secondary",
    "tertiary",
    "info",
    "success",
    "error",
    "warning",
    "dark",
    "light",
    "inverse"
  ]),
  size: g.oneOf(["default", "xsmall", "small", "medium", "large", "xlarge", "xxlarge", "xxxlarge"]),
  flip: g.oneOf(["default", "horizontal", "vertical", "both"])
};
const Ze = {
  size: "default",
  flip: "default"
};
me.displayName = "KendoIcon";
const ve = r.forwardRef((e, t) => {
  const {
    children: n,
    className: o,
    svgClassName: s,
    icon: l,
    flip: c,
    id: i,
    tabIndex: h,
    size: f,
    style: d,
    svgStyle: m,
    themeColor: u,
    viewBox: x,
    name: y,
    onClick: w,
    ...E
  } = e, R = r.useRef(null);
  r.useImperativeHandle(
    t,
    () => ({
      element: R.current
    })
  );
  const M = r.useMemo(
    () => l ? l.name : V.icon,
    [l]
  ), T = r.useMemo(
    () => f || V.size,
    [f]
  ), I = r.useMemo(
    () => c || V.flip,
    [c]
  ), P = r.useMemo(
    () => x || V.viewBox,
    [x]
  ), O = r.useMemo(
    () => We(
      "k-icon",
      "k-svg-icon",
      "k-svg-i-" + M,
      {
        [`k-color-${u}`]: u,
        "k-flip-h": I === "horizontal" || I === "both",
        "k-flip-v": I === "vertical" || I === "both"
      },
      nt[T],
      o
    ),
    [M, u, T, I, o]
  ), p = r.useMemo(
    () => e.width && e.height ? { width: e.width, height: e.height, ...d } : e.width ? { width: e.width, height: e.width, ...d } : e.height ? { width: e.height, height: e.height, ...d } : { ...d },
    [e.width, e.height, d]
  );
  return /* @__PURE__ */ r.createElement(
    "span",
    {
      className: O,
      style: p,
      ref: R,
      onClick: w
    },
    /* @__PURE__ */ r.createElement(
      "svg",
      {
        id: i,
        className: s,
        style: m,
        "aria-hidden": !0,
        tabIndex: h,
        focusable: !1,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: l ? l.viewBox : P,
        dangerouslySetInnerHTML: l ? { __html: l.content } : void 0,
        ...E
      },
      l ? void 0 : n
    )
  );
});
ve.propTypes = {
  style: g.object,
  classNames: g.string,
  children: g.any,
  icon: g.object,
  themeColor: g.oneOf([
    "inherit",
    "primary",
    "secondary",
    "tertiary",
    "info",
    "success",
    "error",
    "warning",
    "dark",
    "light",
    "inverse"
  ]),
  size: g.oneOf(["default", "xsmall", "small", "medium", "large", "xlarge", "xxlarge", "xxxlarge"]),
  flip: g.oneOf(["default", "horizontal", "vertical", "both"])
};
const V = {
  size: "default",
  flip: "default",
  icon: "",
  viewBox: "0 0 24 24"
};
ve.displayName = "KendoSvgIcon";
const st = r.createContext({ type: "svg" });
st.displayName = "KendoReactIconsContext";
const Yt = r.forwardRef((e, t) => {
  var h, f;
  const { type: n, icons: o } = r.useContext(st), { icon: s, ...l } = e;
  let c = n === "svg" ? ((h = e.icon) == null ? void 0 : h.name) || e.name : e.name || ((f = e.icon) == null ? void 0 : f.name);
  c = c && o && o[c] && typeof o[c] == "string" ? o[c] : c;
  const i = c && o && o[c] && typeof o[c] != "string" ? o[c] : s;
  return n === "svg" && i ? /* @__PURE__ */ r.createElement(ve, { ...e, icon: i, ref: t }) : /* @__PURE__ */ r.createElement(me, { ...l, name: c, ref: t });
});
Yt.displayName = "KendoIconWrap";
const Gt = {
  xsmall: "k-fs-xs",
  small: "k-fs-sm",
  medium: "k-fs-md",
  large: "k-fs-lg",
  xlarge: "k-fs-xl"
}, Jt = {
  light: "k-font-weight-light",
  normal: "k-font-weight-normal",
  bold: "k-font-weight-bold"
}, Ut = {
  xsmall: "k-m-xs",
  small: "k-m-sm",
  medium: "k-m-md",
  large: "k-m-lg",
  xlarge: "k-m-xl",
  thin: "k-m-thin",
  hair: "k-m-hair"
}, Zt = {
  xsmall: "xs",
  small: "sm",
  medium: "md",
  large: "lg",
  xlarge: "xl",
  thin: "thin",
  hair: "hair"
}, Vt = {
  top: "k-mt-",
  right: "k-mr-",
  bottom: "k-mb-",
  left: "k-ml-"
}, qt = {
  left: "k-text-left",
  right: "k-text-right",
  center: "k-text-center",
  justify: "k-text-justify"
}, Kt = {
  lowercase: "k-text-lowercase",
  uppercase: "k-text-uppercase",
  capitalize: "k-text-capitalize"
}, Wt = {
  inherit: "k-color-inherit",
  primary: "k-color-primary",
  secondary: "k-color-secondary",
  tertiary: "k-color-tertiary",
  info: "k-color-info",
  success: "k-color-success",
  warning: "k-color-warning",
  error: "k-color-error",
  dark: "k-color-dark",
  light: "k-color-light",
  inverse: "k-color-inverse"
}, S = (e) => {
  const t = r.forwardRef((n, o) => {
    const {
      id: s,
      style: l,
      className: c,
      fontSize: i,
      fontWeight: h,
      textAlign: f,
      textTransform: d,
      themeColor: m,
      margin: u,
      ...x
    } = n, y = r.useRef(null), w = r.useRef(null);
    r.useImperativeHandle(
      y,
      () => ({
        element: w.current,
        props: n
      })
    ), r.useImperativeHandle(o, () => y.current);
    const E = () => `k-${e === "p" ? "paragraph" : e}`, R = e, M = (P, O) => {
      const p = typeof O == "string" ? Zt[O] : O;
      return `${Vt[P]}${p}`;
    }, T = () => {
      if (u !== void 0) {
        if (typeof u == "string")
          return [Ut[u]];
        if (typeof u == "number" && u >= 0 && u <= 24)
          return [`k-m-${u}`];
        if (typeof u == "object") {
          const P = [];
          return Object.keys(u).forEach((p) => {
            u[p] !== null && u[p] !== void 0 && P.push(M(p, u[p]));
          }), P.join(" ");
        }
      }
    }, I = () => [
      E(),
      Gt[i],
      Jt[h],
      qt[f],
      Kt[d],
      Wt[m],
      T(),
      c
    ].filter((p) => p !== void 0).join(" ");
    return /* @__PURE__ */ r.createElement(
      R,
      {
        id: s,
        ref: w,
        className: I(),
        style: l,
        ...x
      },
      n.children
    );
  });
  return t.propTypes = {
    style: g.object,
    className: g.string,
    fontSize: g.oneOf(["xsmall", "small", "medium", "large", "xlarge"]),
    fontWeight: g.oneOf(["light", "normal", "bold"]),
    margin: g.oneOfType([
      g.number,
      g.object,
      g.oneOf(["xsmall", "small", "medium", "large", "xlarge", "thin", "hair"])
    ]),
    textAlign: g.oneOf(["left", "right", "center", "justify"]),
    textTransform: g.oneOf(["lowercase", "uppercase", "capitalize"]),
    themeColor: g.oneOf([
      "inherit",
      "primary",
      "secondary",
      "tertiary",
      "info",
      "success",
      "error",
      "warning",
      "dark",
      "light",
      "inverse"
    ])
  }, t.displayName = `KendoReactTypography${e.toUpperCase()}`, t;
}, _t = S("h1"), $t = S("h2"), en = S("h3"), tn = S("h4"), nn = S("h5"), rn = S("h6"), on = S("p"), sn = S("code"), ln = S("pre"), tr = {
  h1: _t,
  h2: $t,
  h3: en,
  h4: tn,
  h5: nn,
  h6: rn,
  p: on,
  code: sn,
  pre: ln
}, cn = (e) => {
  const [t, n] = Ue(
    null,
    void 0
  ), [o, s] = Ue(
    null,
    void 0
  ), [l, c] = Je([]), [i, h] = Je([]), f = (x) => {
    c({
      type: X.add,
      item: x
    });
  }, d = (x) => {
    c({
      type: X.remove,
      item: x
    });
  }, m = (x) => {
    h({
      type: X.add,
      item: x
    });
  }, u = (x) => {
    h({
      type: X.remove,
      item: x
    });
  };
  return /* @__PURE__ */ r.createElement(rt.Provider, { value: [t, n] }, /* @__PURE__ */ r.createElement(he.Provider, { value: [o, s] }, /* @__PURE__ */ r.createElement(ot.Provider, { value: [l, f, d] }, /* @__PURE__ */ r.createElement(ge.Provider, { value: [i, m, u] }, e.children))));
};
cn.displayName = "KendoReactDragAndDrop";
const an = r.forwardRef((e, t) => {
  const n = r.useRef(null), o = r.useRef(null), s = r.useCallback(
    () => n.current && n.current.element ? n.current.element : n.current,
    [n]
  );
  r.useImperativeHandle(o, () => ({ element: s() || null })), r.useImperativeHandle(t, () => o.current), r.useImperativeHandle(e.childRef, () => n.current);
  const l = r.useCallback(
    (d) => {
      e.onPress && e.onPress({
        element: s(),
        target: o.current,
        event: d
      });
    },
    [s, e.onPress]
  ), c = r.useCallback(
    (d) => {
      e.onRelease && e.onRelease({
        element: s(),
        target: o.current,
        event: d
      });
    },
    [s, e.onRelease]
  ), i = r.useCallback(
    (d) => {
      e.onDragStart && e.onDragStart({
        element: s(),
        target: o.current,
        event: d
      });
    },
    [e, s]
  ), h = r.useCallback(
    (d) => {
      e.onDrag && e.onDrag({
        element: s(),
        target: o.current,
        event: d
      });
    },
    [s, e.onDrag]
  ), f = r.useCallback(
    (d) => {
      e.onDragEnd && e.onDragEnd({
        element: s(),
        target: o.current,
        event: d
      });
    },
    [s, e.onDragEnd]
  );
  return Ft(n, {
    onPress: l,
    onRelease: c,
    onDragStart: i,
    onDrag: h,
    onDragEnd: f
  }, {
    mouseOnly: e.mouseOnly,
    autoScroll: e.autoScroll,
    hint: e.hint,
    scrollContainer: e.scrollContainer
  }), e.children ? r.cloneElement(r.Children.only(e.children), { ref: n }) : null;
});
an.displayName = "KendoReactDraggable";
const un = r.forwardRef((e, t) => {
  const n = r.useRef(null), o = r.useRef(null), s = r.useCallback(
    () => n.current && n.current.element ? n.current.element : n.current,
    [n]
  );
  r.useImperativeHandle(o, () => ({ element: s() || void 0 })), r.useImperativeHandle(t, () => o.current), r.useImperativeHandle(e.childRef, () => n.current);
  const l = r.useCallback(
    (f) => {
      e.onDragEnter && e.onDragEnter({
        element: s(),
        target: o.current,
        event: f
      });
    },
    [e.onDragEnter, s]
  ), c = r.useCallback(
    (f) => {
      e.onDragOver && e.onDragOver({
        element: s(),
        target: o.current,
        event: f
      });
    },
    [s, e.onDragOver]
  ), i = r.useCallback(
    (f) => {
      e.onDragLeave && e.onDragLeave({
        element: s(),
        target: o.current,
        event: f
      });
    },
    [e.onDragLeave, s]
  ), h = r.useCallback(
    (f) => {
      e.onDrop && e.onDrop({
        element: s(),
        target: o.current,
        event: f
      });
    },
    [e.onDrop, s]
  );
  return Xt(n, {
    onDragEnter: l,
    onDragOver: c,
    onDragLeave: i,
    onDrop: h
  }), e.children ? r.cloneElement(r.Children.only(e.children), { ref: n }) : null;
});
un.displayName = "KendoReactDroppable";
const nr = {
  sizeMap: {
    small: "sm",
    medium: "md",
    large: "lg"
  },
  roundedMap: {
    small: "sm",
    medium: "md",
    large: "lg"
  },
  orientationMap: {
    vertical: "vstack",
    horizontal: "hstack"
  }
};
function dn(e, t) {
  return e === t || Number.isNaN(e) && Number.isNaN(t);
}
function fn(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (!dn(e[n], t[n]))
      return !1;
  return !0;
}
function rr(e, t = fn) {
  let n = null;
  function o(...s) {
    if (n && n.lastThis === this && t(s, n.lastArgs))
      return n.lastResult;
    const l = e.apply(this, s);
    return n = {
      lastResult: l,
      lastArgs: s,
      lastThis: this
    }, l;
  }
  return o.clear = function() {
    n = null;
  }, o;
}
const or = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[contenteditable]"
];
class sr {
  constructor(t) {
    this.rovingTabIndex = !0, this.update = () => {
    }, this.focusNextIndex = (n, o) => {
      const s = this.elements;
      let l = s.indexOf(n) + o;
      l = l < 0 ? s.length - 1 : l;
      const c = s[l % s.length];
      return this.focusElement(c, n), c;
    }, this.tabIndex = t.tabIndex || 0, this.root = t.root, this.selectors = t.selectors, this.focusOptions = t.focusOptions || { preventScroll: !0 }, this.rovingTabIndex = t.rovingTabIndex !== void 0 ? t.rovingTabIndex : !0, this.mouseEvents = t.mouseEvents || {}, this.keyboardEvents = t.keyboardEvents || {};
  }
  /**
   * Returns the collection of DOM elements which the module will navigate in.
   */
  get elements() {
    return this.root.current ? Array.from(this.root.current.querySelectorAll(this.selectors.join(","))) : [];
  }
  /**
   * Returns the first navigation DOM element.
   */
  get first() {
    return this.root.current && this.root.current.querySelector(this.selectors.join(",")) || null;
  }
  /**
   * Returns the last navigation DOM element.
   */
  get last() {
    const t = this.elements;
    return t[t.length - 1] || null;
  }
  /**
   * Returns the focused DOM element from the navigation collection of DOM elements.
   */
  get current() {
    return this.elements.find((t) => t.matches(":focus")) || null;
  }
  /**
   * Focuses the next element from the navigation collection of DOM elements.
   */
  focusNext(t) {
    return this.focusNextIndex(t, 1);
  }
  /**
   * Focuses the previous element from the navigation collection of DOM elements.
   */
  focusPrevious(t) {
    return this.focusNextIndex(t, -1);
  }
  /**
   * The keyboard events handler.
   */
  triggerKeyboardEvent(t, n) {
    const o = t.target instanceof Element && t.target.closest(this.selectors.join(",")), s = t.key === " " ? "Space" : t.key, l = t.nativeEvent.type;
    o && this.keyboardEvents[l][s] && this.keyboardEvents[l][s].call(void 0, o, this, t, n);
  }
  /**
   * The mouse events handler.
   */
  triggerMouseEvent(t) {
    const n = t.target instanceof Element && t.target.closest(this.selectors.join(",")), o = t.nativeEvent.type;
    n && this.mouseEvents[o].call(void 0, n, this, t);
  }
  /**
   * Focuses the passed element from the navigation collection of DOM elements.
   */
  focusElement(t, n) {
    t && (n && (this.rovingTabIndex && n.removeAttribute("tabindex"), n.classList.remove("k-focus")), this.rovingTabIndex && t.setAttribute("tabindex", String(this.tabIndex)), t.focus(this.focusOptions));
  }
}
const de = (e) => {
  const t = e.shadowRoot, n = e.contentDocument;
  return t && t.activeElement ? de(t.activeElement) : n && n.activeElement ? de(n.activeElement) : e;
}, lr = (e) => {
  if (!(!e || !e.activeElement))
    return de(e.activeElement);
};
function k(e, t) {
  const n = (e || "").split(".");
  let o = t;
  return n.forEach((s) => {
    o = o ? o[s] : void 0;
  }), o;
}
function cr(e) {
  return e.length !== void 0;
}
class ar {
  constructor(t) {
    this.expandField = t.expandField, this.selectField = t.selectField, this.hasChildrenField = t.hasChildrenField, this.childrenField = t.childrenField, this.textField = t.textField, this.disableField = t.disableField, this.checkField = t.checkField, this.checkIndeterminateField = t.checkIndeterminateField, this.focusIdField = t.focusIdField;
  }
  expanded(t) {
    return k(this.expandField, t);
  }
  selected(t) {
    return k(this.selectField, t);
  }
  text(t) {
    return k(this.textField, t);
  }
  disabled(t) {
    return k(this.disableField, t);
  }
  hasChildren(t) {
    return k(this.hasChildrenField, t);
  }
  children(t) {
    const n = k(this.childrenField, t);
    return n || [];
  }
  checked(t) {
    return k(this.checkField, t);
  }
  checkIndeterminate(t) {
    return k(this.checkIndeterminateField, t);
  }
  focusId(t) {
    return this.focusIdField && k(this.focusIdField, t);
  }
  getChildrenField() {
    return this.childrenField;
  }
}
const hn = 5e4;
class gn {
  constructor() {
    this.objects = [];
  }
  init(t) {
    let n;
    for (let o = 0; o < t.length; o++)
      o % hn === 0 && (n = {}, this.objects.push(n)), n[t[o]] = !0;
  }
  hasId(t) {
    return this.objects.some((n) => n[t]);
  }
}
const Y = "", lt = "0", A = "_";
function ct(e, t, n) {
  if (J(e))
    return t[Number(e)];
  {
    const o = t[Number(H(e))], s = o && o[n] || [];
    return s.length ? ct(B(e), s, n) : void 0;
  }
}
function H(e) {
  return Ce(e) ? e : e.split(A)[0];
}
function B(e) {
  if (Ce(e))
    return e;
  {
    const t = e.indexOf(A);
    return e.substring(t + 1);
  }
}
function mn(e) {
  return G("0", e);
}
function G(e, t) {
  return e = e.toString(), t ? t + A + e : e;
}
function at(e) {
  const t = e.lastIndexOf(A);
  return t < 0 ? Y : e.substring(0, t);
}
function Ce(e) {
  return e === Y || e.indexOf(A) < 0;
}
function J(e) {
  return e !== Y && e.indexOf(A) < 0;
}
function Ee(e) {
  return e.split(A);
}
function be(e) {
  const t = e.lastIndexOf(A);
  return t < 0 ? e : e.substring(t + 1);
}
function vn(e) {
  return be(e) === lt;
}
function Cn(e, t) {
  const n = t;
  e = "r" + A + e, t = "r" + A + t;
  const o = at(e) + A;
  if (t.startsWith(o)) {
    const s = t.substring(o.length);
    if (s) {
      const l = H(s);
      if (Number(be(e)) < Number(l)) {
        const c = o + (Number(l) - 1).toString() + s.substring(l.length);
        return B(c);
      }
    }
  }
  return n;
}
const ir = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EMPTY_ID: Y,
  SEPARATOR: A,
  ZERO_LEVEL_ZERO_NODE_ID: lt,
  createId: G,
  getAllShortIds: Ee,
  getDecrementedItemIdAfterRemoval: Cn,
  getDirectParentId: at,
  getFirstChildId: mn,
  getIdWithoutRootParentId: B,
  getItemById: ct,
  getRootParentId: H,
  getShortId: be,
  isIdEmptyOrZeroLevel: Ce,
  isIdZeroLevel: J,
  isItemFirstFromSiblings: vn
}, Symbol.toStringTag, { value: "Module" }));
function it(e, t) {
  const n = k(t, e);
  return !!(n && n.length);
}
function ur(e, t) {
  return t.expanded(e) && it(e, t.getChildrenField());
}
function dr(e, t, n, o) {
  const s = En([e], t, n, o);
  return s.length ? s[0] : void 0;
}
function En(e, t, n, o) {
  const s = [], l = new gn();
  return l.init(e), ut(l, t, n, Y, s, o), s;
}
function bn(e, t, n, o, s) {
  const l = Number(H(t));
  if (l >= e.length)
    return e;
  let c = e, i = e[l];
  return i[o] || (c = e.slice(), i = c[l] = Object.assign({}, i, { [o]: !0 })), J(t) ? n(i) : i[s] && (i[s] = bn(i[s], B(t), n, o, s)), c;
}
function fr(e, t, n) {
  const o = Ee(e);
  let s = t;
  for (let l = 0; l < o.length; l++) {
    const c = s[Number(o[l])];
    if (n.disabled(c))
      return !1;
    s = c[n.getChildrenField()];
  }
  return !0;
}
function hr(e, t, n, o) {
  return o ? l(e) : s(e, t);
  function s(c, i) {
    let h = [];
    const f = c[n] || [];
    for (let d = 0; d < f.length; d++) {
      const m = G(d, i);
      h.push(m), h = h.concat(s(f[d], m));
    }
    return h;
  }
  function l(c) {
    let i = [];
    const h = c[n] || [];
    for (let f = 0; f < h.length; f++)
      i.push(k(o, h[f])), i = i.concat(l(h[f]));
    return i;
  }
}
function gr(e, t, n, o, s) {
  return (e[o] || []).every((c, i) => s.indexOf(n ? k(n, c) : G(i, t)) > -1);
}
function mr(e, t, n) {
  const o = [], s = Ee(e);
  let l = n;
  for (let c = 0; c < s.length - 1 && l; c++) {
    const i = l[Number(s[c])];
    o.push(i), l = i[t];
  }
  return o;
}
function xn(e, t, n) {
  const o = n.slice();
  if (J(e))
    o.splice(Number(e), 1);
  else {
    const s = Number(H(e)), l = o[s] = { ...o[s] };
    l[t] = xn(B(e), t, l[t]);
  }
  return o;
}
function yn(e, t, n, o, s) {
  const l = s.slice();
  if (J(o))
    if (t === "child") {
      const c = l[Number(o)] = { ...l[Number(o)] };
      c[n] ? (c[n] = c[n].slice(), c[n].push(e)) : c[n] = [e];
    } else
      l.splice(Number(o) + (t === "after" ? 1 : 0), 0, e);
  else {
    const c = Number(H(o)), i = l[c] = { ...l[c] };
    i[n] = yn(e, t, n, B(o), i[n]);
  }
  return l;
}
function ut(e, t, n, o, s, l) {
  for (let c = 0; c < n.length; c++) {
    const i = n[c], h = G(c, o);
    e.hasId(k(t, i)) && s.push(h), it(i, l) && ut(e, t, k(l, i), h, s, l);
  }
}
export {
  Jn as AsyncFocusBlur,
  Ke as BrowserSupportService,
  X as COLLECTION_ACTION,
  cn as DragAndDrop,
  an as Draggable,
  un as Droppable,
  or as FOCUSABLE_ELEMENTS,
  On as FormComponent,
  me as Icon,
  Yt as IconWrap,
  st as IconsContext,
  Rn as Keys,
  sr as Navigation,
  gn as SortedPublicItemIds,
  ve as SvgIcon,
  ar as TreeFieldsService,
  tr as Typography,
  Yn as WatermarkOverlay,
  qe as ZIndexContext,
  yn as addItem,
  gr as areAllDirectChildrenChecked,
  fe as canUseDOM,
  wn as canUseRef,
  We as classNames,
  Pn as clone,
  wt as cloneArray,
  At as cloneDate,
  _e as cloneObject,
  $e as cloneValue,
  Un as createPropsContext,
  Gn as dispatchEvent,
  jn as extendDataItem,
  In as focusFirstFocusableChild,
  lr as getActiveElement,
  hr as getAllDirectIndirectChildrenIds,
  mr as getAllParents,
  de as getInnerActiveElement,
  Qn as getItemPath,
  k as getNestedValue,
  Ln as getScrollbarWidth,
  Mn as getTabIndex,
  Sn as getter,
  Xe as guid,
  it as hasChildren,
  Xn as hasRelativeStackingContext,
  cr as isArray,
  fr as isEnabledAndAllParentsEnabled,
  ur as isItemExpandedAndWithChildren,
  nr as kendoThemeMaps,
  Hn as mapTree,
  Bn as mapTreeItem,
  rr as memoizeOne,
  C as noop,
  xn as removeItem,
  dr as resolveItemId,
  En as resolveItemsIds,
  Tn as setScrollbarWidth,
  Nn as setter,
  Fn as shouldShowValidationUI,
  er as svgIconPropType,
  Qt as toIconClass,
  $n as toIconName,
  ir as treeIdUtils,
  bn as updateItem,
  Lt as useAsyncFocusBlur,
  Je as useCollection,
  Wn as useCustomComponent,
  qn as useDir,
  jt as useDocument,
  Ft as useDraggable,
  Xt as useDroppable,
  Ht as useId,
  Nt as useIsomorphicLayoutEffect,
  Bt as useMouse,
  Tt as usePropsContext,
  Kn as useRtl,
  _n as useWindow,
  An as useZIndexContext,
  zn as validatePackage,
  Vn as withIdHOC,
  Zn as withPropsContext
};
